export const validCurrencies = ['AUD', 'EUR', 'GBP', 'USD'];
